import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchServicesPage } from '../helpers/contentfulHelper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import styles from '../styles/ServicesPage.module.css';

const ServicesPage = () => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const load = async () => {
      const data = await fetchServicesPage();
      setPage(data);
    };
    load();
  }, []);

  if (!page) return null;

  const { title, introCopy, services } = page.fields;

  return (
    <section className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <p className={styles.kicker}>What We Do</p>
          <h1>{title}</h1>
          <div className={styles.intro}>
            {documentToReactComponents(introCopy)}
          </div>
        </header>

        <div className={styles.grid}>
          {(services || []).map((service) => {
            const { title: serviceTitle, excerpt, image, ctaLabel, slug } = service.fields;
            const imageUrl = image?.fields?.file?.url;
            const normalizedSlug = (slug || '').trim();
            const isPathSlug =
              normalizedSlug.startsWith('/') || normalizedSlug.includes('/');
            const targetPath = isPathSlug
              ? (normalizedSlug.startsWith('/') ? normalizedSlug : `/${normalizedSlug}`)
              : `/services/${normalizedSlug}`;

            if (!slug) return null;

            return (
              <article key={service.sys.id} className={styles.card}>
                {imageUrl && (
                  <img
                    src={`https:${imageUrl}`}
                    alt={serviceTitle}
                    className={styles.image}
                  />
                )}

                <div className={styles.cardBody}>
                  <h2 className={styles.cardTitle}>{serviceTitle}</h2>
                  {excerpt && <p className={styles.excerpt}>{excerpt}</p>}
                  <Link to={targetPath} className={styles.button}>
                    {ctaLabel || 'View service'}
                  </Link>
                </div>
              </article>
            );
          })}
        </div>

        <div className={styles.cta}>
          <h3>Need advice on your project?</h3>
          <p>Tell us what you&apos;re planning and we&apos;ll guide the best route forward.</p>
          <Link to="/contact">Make an Enquiry</Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;
